import { getData } from "../../client";
import { showKeys } from "../../queries";

/**
 * The show's event cache entry, spelled once: GET /events/:id, the raw body, under
 * `showKeys.event`. Every reader of the entry spreads it into `useQuery` with a `select` of its
 * own, so two readers can never disagree on the key or the request:
 *
 *     useQuery({ ...eventQueryOptions<Event>(eventId), select: toEditableEvent })
 *
 * `TRaw` is the body as the reader's `select` expects it. An empty event id holds the request,
 * and so does `enabled: false`.
 */
export const eventQueryOptions = <TRaw = unknown>(
  eventId: string,
  enabled = true
) => ({
  queryKey: showKeys.event(eventId),
  queryFn: () => getData<TRaw>(`/events/${eventId}`),
  enabled: enabled && eventId !== "",
});
